module.exports = __webpack_public_path__ + "img/CLS-P-390.c5df48c0.svg";